import { ref } from 'vue';

// True while an app-initiated cross-origin window.location.href is in flight.
// Safari cancels in-flight fetches/chunk imports during cross-origin nav, and
// the resulting AbortErrors / module-import errors must NOT trigger same-origin
// fallbacks (router.onError reload, query.error → /invalid-domain), otherwise
// they would override the cross-origin nav and strand the user on the original
// origin.
export const isExternalRedirectInProgress = ref(false);

export function performExternalRedirect(targetHref: string) {
  isExternalRedirectInProgress.value = true;
  window.location.href = targetHref;
}

// Reset the flag when the page is restored from the bfcache (Safari/Firefox
// back-forward cache preserves JS state). Without this, a user who started a
// cross-origin redirect and then hits Back returns to a SPA whose error
// fallbacks are permanently disabled.
if (typeof window !== 'undefined') {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      isExternalRedirectInProgress.value = false;
    }
  });
}
